import { Error } from '@/components';
import errorImage from '/client-error.svg';

const ClientError = () => {
  return <Error imageSrc={errorImage} errorTitle={'400'} />;
};

export default ClientError;
